import { Expose, Type } from 'class-transformer'
import { BookCollectionPrivacyEnum } from '@interfaces/BookCollectionPrivacyEnum'
import { MyBookType } from './MyBookType'

export class BookCollectionType {
  @Expose()
  id: number

  @Expose()
  collectionName: string

  @Expose()
  description: string

  @Expose()
  privacyType: BookCollectionPrivacyEnum

  @Expose()
  @Type(() => MyBookType)
  books: MyBookType[]
}
